export default __webpack_public_path__ + "static/dashboard-screenshot-b1de35c502df5d48d4f57e2dcf6ea95f.png";